import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { onInstallPromptChange, triggerInstallPrompt } from "@/lib/pwa";

const DISMISS_KEY = "vm_install_dismissed_v1";

export default function InstallPrompt() {
    const [available, setAvailable] = useState(false);
    const [dismissed, setDismissed] = useState(
        () => typeof window !== "undefined" && localStorage.getItem(DISMISS_KEY) === "1"
    );

    useEffect(() => onInstallPromptChange(setAvailable), []);

    if (!available || dismissed) return null;

    const install = async () => {
        const { outcome } = await triggerInstallPrompt();
        if (outcome === "accepted" || outcome === "dismissed") {
            setAvailable(false);
        }
    };

    const dismiss = () => {
        localStorage.setItem(DISMISS_KEY, "1");
        setDismissed(true);
    };

    return (
        <div
            data-testid="install-prompt"
            className="fixed bottom-16 right-4 z-40 journal-card shadow-lg max-w-xs p-4 flex items-start gap-3"
        >
            <Download className="w-5 h-5 text-[var(--vm-accent)] mt-0.5 shrink-0" />
            <div className="flex-1 min-w-0">
                <div className="font-serif-display text-lg text-[var(--vm-text)] leading-tight">
                    Install rooteed
                </div>
                <p className="text-xs text-[var(--vm-text-muted)] mt-1">
                    Add to your home screen for one-tap garden planning — works offline for
                    the last viewed dashboard.
                </p>
                <div className="flex gap-2 mt-2">
                    <Button
                        type="button"
                        size="sm"
                        data-testid="install-prompt-accept"
                        onClick={install}
                        className="rounded-full h-7 bg-[var(--vm-accent)] hover:bg-[var(--vm-accent-hover)] text-[var(--vm-bg)] text-xs"
                    >
                        Install
                    </Button>
                    <Button
                        type="button"
                        size="sm"
                        variant="ghost"
                        data-testid="install-prompt-dismiss"
                        onClick={dismiss}
                        className="rounded-full h-7 text-xs text-[var(--vm-text-muted)]"
                    >
                        Not now
                    </Button>
                </div>
            </div>
            <button
                type="button"
                onClick={dismiss}
                className="text-[var(--vm-text-muted)] hover:text-[var(--vm-text)] p-1"
                aria-label="Dismiss install prompt"
                data-testid="install-prompt-close"
            >
                <X className="w-4 h-4" />
            </button>
        </div>
    );
}
